/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { TModalTypes, ModalOuter } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import TextInput from "../../../components/InputWrapper/TextInput"
import { TSyaryoTenkenList } from "../../../service/truck/tenken/TTenken"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONST from "../../../constant"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import TenkenSeibiModal from "./TenkenseibiModal"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"

/**
 * 点検整備リストモーダル
 * 選択月の登録データをリスト表示し、
 * データ重複時の編集及び既存データ存在時の新規登録を補助するModal
 * @param {*} props
 * @return {*} reactNode
 */
const TenkenSeibiListModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title: string
    footer?: React.ReactNode
    車輌ID: number
    予定年月?: string
    実施年月?: string
    部所名: string
    車番: string
    点検整備List?: TSyaryoTenkenList[]
  }
> = (props) => {
  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TSyaryoTenkenList>) => {
    return new wjCore.CollectionView(data, {})
  }

  // グリッド初期化時イベントハンドラ　祝日
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット 祝日
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
    }
  }
  //#endregion

  //#region [state]

  // state
  const [点検整備ID, set点検整備ID] = useState<number>()

  // grid
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })
  const [pageSize, setPageSize] = useState<number>(10)

  // init
  const [isComponentInit, setIsComponentInit] = useState(false)
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(true)

  // modal
  const [isTenkenEditModalShow, setIsTenkenEditModalShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [effect]
  // componentチェック
  useEffect(() => {
    setAlertSource(undefined)
    if (props.isShow) {
      if (!isComponentInit) setIsComponentInit(true)
    } else {
      set点検整備ID(undefined)
      const targetList: TSyaryoTenkenList[] = []
      setGridData({
        data: createCollectionView(targetList),
      })
      setIsSpinnerShow(true)
      setIsComponentInit(false)
    }
  }, [isComponentInit, props.isShow])

  useEffect(() => {
    if (isComponentInit && gridInitialized) {
      const targetList: TSyaryoTenkenList[] = []
      setGridData({
        data: createCollectionView(props.点検整備List ?? targetList),
      })
      setIsSpinnerShow(false)
    } else {
      setIsSpinnerShow(true)
    }
  }, [isComponentInit, gridInitialized])

  //#endregion
  return (
    <>
      <ModalOuter
        isShow={props.isShow}
        title={props.title}
        setIsShow={props.setIsShow}
        size={"xl"}>
        <Spinner inModal searching={isSpinnerShow}></Spinner>
        <Container fluid className="label-form">
          {/* アラート表示 */}
          <Row>
            <Col>
              <LocalAlertComponent alertSource={AlertSource} />
            </Col>
          </Row>
          <form>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-6rem">部所</th>
                      <td>
                        <TextInput
                          style={{ width: "15rem" }}
                          id="部所名"
                          name="部所名"
                          value={props.部所名}
                          isReadOnly={true}
                          setValue={(v) => {}}
                        />
                      </td>
                      <th className="min-w-6rem">車番</th>
                      <td>
                        <TextInput
                          style={{ width: "5rem" }}
                          id="車番"
                          name="車番"
                          value={props.車番}
                          isReadOnly={true}
                          setValue={(v) => {}}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <br></br>
            <div className="overflow-auto">
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={0}
                gridId={"tenkenseibilistmodal"}
                isRestoreSearching={false}
                setIsRestoreSearching={(v) => {}}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                isShowGridFooter={false}
                headerComponent={
                  <>
                    <Button
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        // 点検整備IDは初期化
                        set点検整備ID(undefined)
                        setIsTenkenEditModalShow(true)
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      新規追加
                    </Button>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  align="center"
                  width={90}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyaryoTenkenList>
                    ) => {
                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            set点検整備ID(context.item.車輌点検整備ID)
                            // 編集Modalを起動
                            setIsTenkenEditModalShow(true)
                          }}>
                          編集
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="登録番号"
                  width={160}
                  header="登録番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌点検整備区分名称1"
                  width={200}
                  header="点検整備名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="点検整備予定日"
                  width={120}
                  header="予定日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyaryoTenkenList>
                    ) => {
                      return (
                        <>
                          {context.item.点検整備予定日 &&
                            wjCore.Globalize.format(
                              new Date(context.item.点検整備予定日),
                              "d"
                            )}
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="点検整備実施日"
                  width={120}
                  header="実施日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyaryoTenkenList>
                    ) => {
                      return (
                        <>
                          {context.item.点検整備実施日 &&
                            wjCore.Globalize.format(
                              new Date(context.item.点検整備実施日),
                              "d"
                            )}
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="支払先名"
                  width={150}
                  header="整備業者名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  binding="点検整備費"
                  format="n"
                  width={130}
                  header="整備費用"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="費用備考"
                  header="費用備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </div>
          </form>
        </Container>
      </ModalOuter>
      <TenkenSeibiModal
        title="点検整備入力"
        modalType="点検整備"
        isShow={isTenkenEditModalShow}
        setIsShow={setIsTenkenEditModalShow}
        ListModalIsShow={props.setIsShow}
        車輌Id={props.車輌ID}
        予定年月={props.予定年月}
        実施年月={props.実施年月}
        車輌点検整備id={点検整備ID}></TenkenSeibiModal>
    </>
  )
}

export default TenkenSeibiListModal
